import styles from './home-public.module.scss';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '../../sharedComponents/Typography/Typography';
import AuthIcon from './AuthIcon';

const HomePublic: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.contentShell}>
        <div className={styles.hero}>
          <Typography variant="h4" className={styles.heroTitle}>
            {t('sunshine.content.home_public.hero.header')}
          </Typography>
          <Typography variant="body-3" className={styles.heroCopy}>
            {t('sunshine.content.home_public.hero.explainer')}
          </Typography>
        </div>
        <div className={styles.authLinkContainer}>
          <div className={styles.authReminderContainer}>
            <div className={styles.iconDotContainerDark} aria-hidden="true">
              <span className={styles.infoIcon}>i</span>
            </div>
            <div className={styles.cardContent}>
              <Typography variant="h5" className={styles.reminderTitle}>
                {t(
                  'sunshine.content.home_public.account_creation_reminder.header',
                )}
              </Typography>
              <div className={styles.buttonMainText}>
                <Typography variant="body-3">
                  {t(
                    'sunshine.content.home_public.account_creation_reminder.explainer',
                  )}
                </Typography>
              </div>
            </div>
          </div>
          <button
            type="button"
            className={styles.createAccountContainer}
            onClick={() => navigate('/signup')}
          >
            <div className={styles.iconDotContainer} aria-hidden="true">
              <AuthIcon name="person" />
            </div>
            <div className={styles.cardContent}>
              <Typography variant="label-1" className={styles.cardEyebrow}>
                {t('sunshine.content.home_public.create_account.header')}
              </Typography>
              <div className={styles.buttonMainText}>
                <Typography variant="h4" className={styles.cardTitle}>
                  {t('sunshine.action.create_account')}
                </Typography>
                <span className={styles.linkChevron} aria-hidden="true">
                  ›
                </span>
              </div>
            </div>
          </button>
          <Typography variant="body-4">
            {t('sunshine.content.home_public.create_account.email_reminder')}
          </Typography>
          <button
            type="button"
            className={styles.logInContainer}
            onClick={() => navigate('/login')}
          >
            <div className={styles.iconDotContainer} aria-hidden="true">
              <AuthIcon name="lock" />
            </div>
            <div className={styles.cardContent}>
              <Typography variant="label-1" className={styles.cardEyebrow}>
                {t('sunshine.content.home_public.login.header')}
              </Typography>
              <div className={styles.buttonMainText}>
                <Typography variant="h4" className={styles.cardTitle}>
                  {t('sunshine.action.log_in')}
                </Typography>
                <span className={styles.linkChevron} aria-hidden="true">
                  ›
                </span>
              </div>
            </div>
          </button>
        </div>
        <div className={styles.helperContainer}>
          <div className={styles.helperBorder}>
            <Typography variant="body-2" className={styles.helperTitle}>
              {t('sunshine.content.home_public.account_tips.header')}
            </Typography>
            <Typography variant="body-3" className={styles.helperBody}>
              {t('sunshine.content.home_public.account_tips.email_address')}
            </Typography>
            <Typography variant="body-2" className={styles.helperSupport}>
              {t(
                'sunshine.content.home_public.account_tips.email_address.explainer',
              )}
            </Typography>
            <div className={styles.helperDivider} aria-hidden="true" />
            <Typography variant="body-3" className={styles.helperSubhead}>
              {t(
                'sunshine.content.home_public.account_tips.avoid_typos.header',
              )}
            </Typography>
            <Typography variant="body-2" className={styles.helperSupport}>
              {t(
                'sunshine.content.home_public.account_tips.avoid_typos.explainer',
              )}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePublic;
